var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A34A"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 6C28 6 12 18 12 36c0 4 1 7 3 10 20 0 39-12 39-40z",
    fill: "url(#leaf)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44C24 32 34 22 46 15",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 50h30c4 0 6-2 6-5s-3-4-5-3",
    fill: "none",
    stroke: "#38B2F5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 58h40c4 0 6 2 6 4",
    fill: "none",
    stroke: "#38B2F5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirQuality);
export default __webpack_public_path__ + "static/media/airQuality.b3bd7f3daca619cf8dac594753b471ce.svg";
export { ForwardRef as ReactComponent };